import { group } from 'd3';
import getBandwidth from '../../../primitives/shape/utils/getBandwidth';
export function getHorizontalBarGroups(data, groupScale, xScale, yScale, colorScale, groupAccessor, valueAccessor, colorAccessor, xAccessor) {
  const barWidth = getBandwidth(groupScale);
  const groups = group(data, groupAccessor);
  const barGroups = Array.from(groups).map((_ref, i) => {
    let [key, entries] = _ref;
    return {
      index: i,
      x0: groupScale(key),
      bars: entries.map((d, j) => {
        return {
          index: j,
          key: key,
          datum: d,
          height: barWidth,
          xValue: xAccessor(d) || 0,
          yValue: valueAccessor(d) || 0,
          label: colorAccessor(d) || '',
          y: yScale(xAccessor(d)) || 0,
          x: 0,
          color: colorScale(colorAccessor(d)),
          width: xScale(valueAccessor(d)) || 0
        };
      })
    };
  });
  return barGroups;
}